import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import {
  ISystemConfig,
  SystemConfigInfo,
} from "@/store/system/interfaces/SystemConfigInterface";
import { mutation, query } from "@/core/services/ApolloService";
import { setError } from "@/core/services/HandlerService";
import SYSTEM_CONFIG from "@/graphql/system/SystemConfig.graphql";
import UPDATE_SYSTEM_CONFIG from "@/graphql/system/UpdateSystemConfig.graphql";

@Module({
  name: "system/SystemConfigModule",
  namespaced: true,
  dynamic: true,
  // preserveState: true,
  stateFactory: true,
  store: store,
})
export default class SystemConfigModule
  extends VuexModule
  implements SystemConfigInfo
{
  error: string | null = null;
  systemConfig: ISystemConfig = {
    id: null,
    appLogo: null,
    companyName: null,
    companyIdNumber: null,
    companyAddressLine1: null,
    companyAddressLine2: null,
    companyEmail: null,
    companyPhoneNumber: null,
    saleCommissionPercentage: null,
  };

  /**
   * @description Get systemConfig errors
   * @returns array
   */
  get getError() {
    return this.error;
  }

  get currentSystemConfig(): ISystemConfig {
    return this.systemConfig;
  }

  @Mutation
  setError(error) {
    this.error = error;
  }

  @Mutation
  setSystemConfig(systemConfig) {
    this.systemConfig = systemConfig;
  }

  @Action
  async getSystemConfig(): Promise<ISystemConfig | null> {
    try {
      const data = await query(SYSTEM_CONFIG);

      this.setSystemConfig(data.systemConfig);
      return data.systemConfig;
    } catch (e) {
      await setError(this, e);
    }

    return null;
  }

  @Action
  async updateSystemConfig(payload): Promise<ISystemConfig | null> {
    try {
      const data = await mutation(UPDATE_SYSTEM_CONFIG, payload);

      this.setSystemConfig(data.updateSystemConfig);
      return data.updateSystemConfig;
    } catch (e) {
      await setError(this, e);
    }

    return null;
  }
}
